import { render, staticRenderFns } from "./wt8.vue?vue&type=template&id=f1181796&scoped=true&"
import script from "./wt8.vue?vue&type=script&lang=js&"
export * from "./wt8.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=f1181796&prod&scoped=true&lang=css&"
import style1 from "./wt8.vue?vue&type=style&index=1&id=f1181796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1181796",
  null
  
)

export default component.exports